<template>
  <div class="space-y-2">
    <div class="flex items-center gap-2">
      <ConfigHelpLabel label="粗细" help-key="block_divider_height" label-class="text-[10px] text-gray-500 w-10" tag="span" />
      <input type="range" v-model.number="block.data.height" min="1" max="10" step="1" class="flex-1 h-1 accent-blue-600" @input="$emit('update')" />
      <span class="text-[10px] text-gray-400 w-8 text-right">{{ block.data.height }}px</span>
    </div>
    <div class="flex items-center gap-2">
      <ConfigHelpLabel label="颜色" help-key="block_divider_color" label-class="text-[10px] text-gray-500 w-10" tag="span" />
      <input type="color" :value="block.data.color || '#e5e7eb'" @input="block.data.color = $event.target.value; $emit('update')" class="h-6 w-10 rounded border border-gray-300 cursor-pointer" />
      <input v-model="block.data.color" @input="$emit('update')" placeholder="#e5e7eb" class="flex-1 px-2 py-1 border border-gray-300 rounded text-xs" />
    </div>
    <div class="flex items-center gap-2">
      <ConfigHelpLabel label="样式" help-key="block_divider_style" label-class="text-[10px] text-gray-500 w-10" tag="span" />
      <select v-model="block.data.style" @change="$emit('update')" class="flex-1 px-2 py-1 border border-gray-300 rounded text-xs">
        <option value="solid">实线</option>
        <option value="dashed">虚线</option>
        <option value="dotted">点线</option>
      </select>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String] })
defineEmits(['update'])
onMounted(() => {
  if (!props.block.data) props.block.data = {}
  if (props.block.data.height == null) props.block.data.height = 1
  if (!props.block.data.style) props.block.data.style = 'solid'
})
</script>
